<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'CheckboxItem',
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      checked: {
        type: Boolean,
        default: false,
      },
      checkBoxClass: {
        type: String,
        default: '',
      },
      ariaRequired: {
        type: Boolean,
        default: false,
      },
      ariaDescribedby: {
        type: String,
        default: '',
      },
      ariaLabel: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      id: {
        type: String,
        default: '',
      },
    },
    emits: ['update:modelValue'],
    computed: {
      internalValue: {
        get() {
          return this.modelValue
        },
        set(v: boolean) {
          this.$emit('update:modelValue', v)
        },
      },
      checkboxId() {
        return this.id || `checkbox-${Math.random().toString(36).substr(2, 9)}`
      },
    },
  })
</script>

<template>
  <label :class="checkBoxClass" :for="checkboxId">
    <span class="sr-only"> {{ label }}</span>
    <input
      :id="checkboxId"
      v-model="internalValue"
      type="checkbox"
      class="mr-3"
      :checked="checked"
      :aria-checked="internalValue || checked"
      :aria-required="ariaRequired"
      :aria-describedby="ariaDescribedby"
      :aria-label="ariaLabel"
      :class="internalValue || checked ? 'checked' : ''"
    />
    <slot></slot>
  </label>
</template>

<style scoped lang="scss">
  input[type='checkbox'] {
    appearance: none;
    width: 16px;
    height: 16px;
    background-color: var(--color-white);
    border: 1px solid var(--color-border-grey);
    border-radius: 2.5px;
    transition: 0.2s all linear;

    &:focus {
      outline: 2px solid var(--color-bright-blue);
      outline-offset: 2px;
    }

    &:checked {
      background-color: var(--carrot-orange);
      border-color: var(--carrot-orange);
      position: relative;

      &::after {
        content: '';
        position: absolute;
        z-index: 3;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background: url('@/assets/icons/icon-checklist.svg') no-repeat;
      }
    }
  }
</style>
